var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h100-vh-min pad20 bg-f2" },
    [
      _c("div", { staticClass: "f22 mar20-b lh-1 flex-shrink" }, [
        _vm._v(_vm._s(_vm.type == "1" ? "部分" : "整单") + "发货")
      ]),
      _c(
        "el-alert",
        {
          staticClass: "radius10",
          attrs: { title: "温馨提示", type: "warning", closable: false }
        },
        [
          _c("p", [_vm._v("发货方式支持送货上门、物流发货和快递发货")]),
          _c("p", [
            _vm._v("如货品含有处方药，请与买家联系获取处方或证明信息上传凭证")
          ])
        ]
      ),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "bg-white pad15 f15 radius10" },
        [
          _vm.type == "0"
            ? [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.goodsList }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "goodsName", label: "商品名称" }
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "goodsQuantity", label: "数量" }
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "sellFactPrice", label: "价格" }
                    }),
                    _c("el-table-column", {
                      attrs: { label: "金额" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      (
                                        scope.row.sellFactPrice *
                                        scope.row.goodsQuantity
                                      ).toFixed(2)
                                    ) +
                                    "\n          "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1473998854
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { label: "实发数量" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("el-input-number", {
                                  staticClass: "w100-full",
                                  attrs: {
                                    size: "small",
                                    placeholder: "请输入",
                                    min: 0,
                                    max: scope.row.remainGoodsQuantity,
                                    step: 1,
                                    disabled: scope.row.remainGoodsQuantity == 0
                                  },
                                  on: {
                                    change: function(currentValue) {
                                      return _vm.finalGoodsQuantityChange(
                                        currentValue,
                                        scope
                                      )
                                    }
                                  },
                                  model: {
                                    value: scope.row.finalGoodsQuantity,
                                    callback: function($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "finalGoodsQuantity",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.finalGoodsQuantity"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1428635224
                      )
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "remark", label: "备注" }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "pad20-t text-right" }, [
                  _vm._v("运费：" + _vm._s(_vm.freightMoney) + "元")
                ])
              ]
            : _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.goodsList }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "商品名称" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "sellFactPrice", label: "价格" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "goodsQuantity", label: "下单数量" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "deliveryGoodsQuantity", label: "已发数量" }
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "remainGoodsQuantity", label: "可发数量" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "本次发货数量" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-input-number", {
                              staticClass: "w100-full",
                              attrs: {
                                size: "small",
                                placeholder: "请输入",
                                min: 0,
                                max: scope.row.remainGoodsQuantity,
                                step: 1,
                                disabled: scope.row.remainGoodsQuantity == 0
                              },
                              model: {
                                value: scope.row.finalGoodsQuantity,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "finalGoodsQuantity", $$v)
                                },
                                expression: "scope.row.finalGoodsQuantity"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
        ],
        2
      ),
      _vm.balanceRefundTotal &&
      _vm.consigneeInfo.paymentType == "1" &&
      _vm.consigneeInfo.paymentSt == 9
        ? _c(
            "el-alert",
            {
              staticClass: "mar20-t radius10",
              attrs: {
                title: "请提醒客户注意查收",
                type: "success",
                closable: false
              }
            },
            [
              _c("p", [
                _vm._v(
                  "订单涉及商品调整，预计产生退款 ￥" +
                    _vm._s(_vm.balanceRefundTotal)
                )
              ]),
              _c("p", [
                _vm._v("退款将在订单完成后，退还至客户的付款账户/预付款账户")
              ])
            ]
          )
        : _vm._e(),
      _vm._m(1),
      _c(
        "div",
        { staticClass: "bg-white pad15 f15 radius10" },
        [
          _vm.consigneeInfo.orderTransportDtlBo
            ? _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "fb" }, [_vm._v("配送方式：")]),
                    _vm._v(
                      _vm._s(
                        _vm.consigneeInfo.delivery == "2"
                          ? "买家自提"
                          : "卖家配送"
                      ) + " "
                    )
                  ]),
                  _vm.consigneeInfo.delivery == "2"
                    ? [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("span", { staticClass: "fb" }, [
                            _vm._v("自提时间：")
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                !_vm.consigneeInfo.orderTransportDtlBo
                                  .selfPickupTimeType
                                  ? _vm.consigneeInfo.orderTransportDtlBo
                                      .pickupTime
                                  : _vm.consigneeInfo.orderTransportDtlBo
                                      .sellerConfirmPickupTime
                                  ? _vm.consigneeInfo.orderTransportDtlBo
                                      .sellerConfirmPickupTime
                                  : "待卖家确认"
                              ) +
                              "\n        "
                          )
                        ]),
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("span", { staticClass: "fb" }, [
                            _vm._v("买家留言：")
                          ]),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.consigneeInfo.memo == ""
                                  ? "无"
                                  : _vm.consigneeInfo.memo
                              ) +
                              "\n        "
                          )
                        ])
                      ]
                    : [
                        _c("el-col", { attrs: { span: 12 } }, [
                          _c("span", { staticClass: "fb" }, [
                            _vm._v("买家收货地址：")
                          ]),
                          _vm._v(
                            _vm._s(_vm.consigneeInfo.orderTransportDtlBo.addr) +
                              " "
                          )
                        ])
                      ],
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "fb" }, [_vm._v("收货人：")]),
                    _vm._v(
                      _vm._s(_vm.consigneeInfo.orderTransportDtlBo.linkman)
                    )
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "fb" }, [_vm._v("联系方式：")]),
                    _vm._v(_vm._s(_vm.consigneeInfo.orderTransportDtlBo.tel))
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._m(2),
      _c(
        "div",
        { staticClass: "bg-white pad15-lr pad15-b f15 radius10" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabs",
              model: {
                value: _vm.logisticsType,
                callback: function($$v) {
                  _vm.logisticsType = $$v
                },
                expression: "logisticsType"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "送货上门", name: "SHSM" } },
                [
                  _vm._l(_vm.SHSM, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flex items-center mar15-b" },
                      [
                        _c("div", [_vm._v("送货人：")]),
                        _c("el-input", {
                          staticClass: "w200 mar15-r",
                          attrs: {
                            size: "small",
                            maxlength: "20",
                            placeholder: "请输入",
                            clearable: ""
                          },
                          model: {
                            value: item.logisticsCompanyName,
                            callback: function($$v) {
                              _vm.$set(item, "logisticsCompanyName", $$v)
                            },
                            expression: "item.logisticsCompanyName"
                          }
                        }),
                        _c("div", [_vm._v("车牌号：")]),
                        _c("el-input", {
                          staticClass: "w200 mar15-r",
                          attrs: {
                            size: "small",
                            placeholder: "请输入",
                            maxlength: "20",
                            clearable: ""
                          },
                          model: {
                            value: item.licensePlate,
                            callback: function($$v) {
                              _vm.$set(item, "licensePlate", $$v)
                            },
                            expression: "item.licensePlate"
                          }
                        }),
                        _c("div", [_vm._v("联系电话：")]),
                        _c("el-input", {
                          staticClass: "w200 mar15-r",
                          attrs: {
                            size: "small",
                            placeholder: "请输入",
                            maxlength: "20",
                            clearable: "",
                            oninput: "value=value.replace(/[^\\d]/g,'')"
                          },
                          model: {
                            value: item.logisticsInfo,
                            callback: function($$v) {
                              _vm.$set(item, "logisticsInfo", $$v)
                            },
                            expression: "item.logisticsInfo"
                          }
                        }),
                        _vm.SHSM.length > 1
                          ? _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.SHSMRemove(index)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "mar10-t",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        icon: "el-icon-plus"
                      },
                      on: { click: _vm.SHSMAdd }
                    },
                    [_vm._v("增加")]
                  )
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "物流发货", name: "LOGISTICS" } },
                [
                  _vm._l(_vm.LOGISTICS, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flex items-center mar15-b" },
                      [
                        _c("div", [_vm._v("物流公司：")]),
                        _c("el-autocomplete", {
                          staticClass: "w200 mar15-r",
                          attrs: {
                            size: "small",
                            placeholder: "请输入",
                            "value-key": "logisticsCompanyName",
                            clearable: "",
                            "fetch-suggestions":
                              _vm.recentLogisticsCompanySuggestions
                          },
                          model: {
                            value: item.logisticsCompanyName,
                            callback: function($$v) {
                              _vm.$set(item, "logisticsCompanyName", $$v)
                            },
                            expression: "item.logisticsCompanyName"
                          }
                        }),
                        _c("div", [_vm._v("物流单号：")]),
                        _c("el-input", {
                          staticClass: "w200 mar15-r",
                          attrs: {
                            size: "small",
                            placeholder: "请输入",
                            maxlength: "20",
                            clearable: ""
                          },
                          model: {
                            value: item.logisticsNum,
                            callback: function($$v) {
                              _vm.$set(item, "logisticsNum", $$v)
                            },
                            expression: "item.logisticsNum"
                          }
                        }),
                        _c("div", [_vm._v("联系电话：")]),
                        _c("el-input", {
                          staticClass: "w200 mar15-r",
                          attrs: {
                            size: "small",
                            placeholder: "请输入",
                            maxlength: "20",
                            clearable: "",
                            oninput: "value=value.replace(/[^\\d]/g,'')"
                          },
                          model: {
                            value: item.logisticsInfo,
                            callback: function($$v) {
                              _vm.$set(item, "logisticsInfo", $$v)
                            },
                            expression: "item.logisticsInfo"
                          }
                        }),
                        _vm.LOGISTICS.length > 1
                          ? _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.LOGISTICSRemove(index)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "mar10-t",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        icon: "el-icon-plus"
                      },
                      on: { click: _vm.LOGISTICSAdd }
                    },
                    [_vm._v("增加")]
                  )
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "快递发货", name: "EXPRESS" } },
                [
                  _vm._l(_vm.EXPRESS, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flex items-center mar15-b" },
                      [
                        _c("div", [_vm._v("快递公司：")]),
                        _c(
                          "el-select",
                          {
                            staticClass: "w200 mar15-r",
                            attrs: { size: "small", placeholder: "请选择" },
                            on: {
                              change: function(val) {
                                return _vm.logisticsCompany(val, index)
                              }
                            },
                            model: {
                              value: item.logisticsCompanyCode,
                              callback: function($$v) {
                                _vm.$set(item, "logisticsCompanyCode", $$v)
                              },
                              expression: "item.logisticsCompanyCode"
                            }
                          },
                          _vm._l(_vm.expressCompanyList, function(item2) {
                            return _c("el-option", {
                              key: item2.id,
                              attrs: {
                                label: item2.description,
                                value: item2.code
                              }
                            })
                          }),
                          1
                        ),
                        _c("div", [_vm._v("快递单号：")]),
                        _c("el-input", {
                          staticClass: "w200 mar15-r",
                          attrs: {
                            size: "small",
                            placeholder: "请输入",
                            maxlength: "20",
                            clearable: ""
                          },
                          model: {
                            value: item.logisticsNum,
                            callback: function($$v) {
                              _vm.$set(item, "logisticsNum", $$v)
                            },
                            expression: "item.logisticsNum"
                          }
                        }),
                        _vm.EXPRESS.length > 1
                          ? _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.EXPRESSRemove(index)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "mar10-t",
                      attrs: {
                        size: "mini",
                        type: "primary",
                        icon: "el-icon-plus"
                      },
                      on: { click: _vm.EXPRESSAdd }
                    },
                    [_vm._v("增加")]
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bg-white pad15 mar15-t f15 radius10" },
        [
          _vm._m(3),
          _c(
            "el-upload",
            {
              staticClass: "picture-card",
              attrs: {
                "list-type": "picture-card",
                multiple: "",
                timeout: 600000,
                action: _vm.voucherAction,
                limit: 30,
                "file-list": _vm.imgList,
                "on-exceed": _vm.voucherUploadExceed,
                "before-upload": _vm.voucherUploadBefore,
                "on-change": _vm.voucherUploadChange
              },
              scopedSlots: _vm._u([
                {
                  key: "file",
                  fn: function(ref) {
                    var file = ref.file
                    return _c("div", {}, [
                      _c("img", {
                        staticClass: "el-upload-list__item-thumbnail",
                        attrs: {
                          src: /(zip)$/gi.test(file.name)
                            ? "https://files.nxin.com/mobile/public/undefined.png"
                            : file.url
                        }
                      }),
                      _c(
                        "span",
                        { staticClass: "el-upload-list__item-actions" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "el-upload-list__item-preview",
                              on: {
                                click: function($event) {
                                  return _vm.voucherPreview(file)
                                }
                              }
                            },
                            [_c("i", { staticClass: "el-icon-zoom-in" })]
                          ),
                          _vm.voucherUploadDelDisabled(file.url)
                            ? _c(
                                "span",
                                {
                                  staticClass: "el-upload-list__item-delete",
                                  on: {
                                    click: function($event) {
                                      return _vm.voucherRemove(file)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "el-icon-delete" })]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  }
                }
              ])
            },
            [
              _c("i", {
                staticClass: "el-icon-plus",
                staticStyle: { transform: "scale(0.8)" },
                attrs: { slot: "default" },
                slot: "default"
              })
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "pad50" }),
      _c(
        "div",
        { staticClass: "text-right suction-bottom" },
        [
          _c(
            "el-button",
            {
              staticClass: "pad30-lr",
              on: {
                click: function($event) {
                  return _vm.$router.back()
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              staticClass: "pad30-lr",
              attrs: { type: "primary" },
              on: { click: _vm.logisticsSubmit }
            },
            [_vm._v("发 货")]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.voucherDialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.voucherDialogVisible = $event
            }
          }
        },
        [_c("img", { attrs: { width: "100%", src: _vm.voucherUrl } })]
      ),
      _c("HlCart", { ref: "hlCart", on: { confirm: _vm.HlCartConfirm } }),
      _c("contractPreview", {
        attrs: {
          type: "sign",
          isAutoSignAuth: true,
          url: _vm.contractPreviewUrl,
          visible: _vm.contractPreviewVisible
        },
        on: {
          "update:visible": function($event) {
            _vm.contractPreviewVisible = $event
          },
          confirm: _vm.contractPreviewConfirm
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pad20-t pad15-b f16" }, [
      _vm._v("第一步"),
      _c("span", { staticClass: "pad10-l" }, [_vm._v("确认订单信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pad20-t pad15-b f16" }, [
      _vm._v("第二步"),
      _c("span", { staticClass: "pad10-l" }, [_vm._v("确认配送信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pad20-t pad15-b f16" }, [
      _vm._v("第三步"),
      _c("span", { staticClass: "pad10-l" }, [_vm._v("选择发货方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mar15-b" }, [
      _c("span", { staticClass: "fb pad10-r" }, [_vm._v("上传凭证")]),
      _c("span", { staticClass: "red f12" }, [
        _vm._v(
          "仅支持图片和ZIP压缩包，最多上传30张, 若要删除已上传的凭证，请在订单详情页-订单凭证中操作"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }